export interface ISaveProps {
	name: string;
	mode: 'sport' | 'comfort' | 'drift';
	info: string;
	author: string;
	creationDate: string;
	selected?: boolean;
	isFavorite: boolean;
	isNetwork?: boolean;
	list: 'favorite' | 'nonFavorite';
}

enum popups {
	Upload = 'upload',
	Favorite = 'favorite',
	Setup = 'setup',
	Delete = 'delete',
}

const popupText = {
	[popups.Upload]: 'Загрузить в сеть',
	[popups.Favorite]: 'Добавить в избранное',
	[popups.Setup]: 'Установить',
	[popups.Delete]: 'Удалить настройку',
};

const popupPosition = {
	[popups.Upload]: 140,
	[popups.Favorite]: 10,
	[popups.Setup]: 130,
	[popups.Delete]: 145,
};

export { popupPosition, popups, popupText };
